import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { WidthWrapper } from '../../components/Layout/styles';

import { SimpleWorkTile } from './components/SimpleWorkTile';

const Wrapper = styled.section`
  background-color: #ffffff;
  padding: 40px 20px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);

  @media (min-width: 768px) {
    padding: 40px 40px;
  }
`;

const Content = styled.article`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 1000px;
  margin: 0 auto;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 80px;

    > *:not(:last-child):after {
      content: url('/images/assets/arrow.png');
      position: absolute;
      width: auto;
      height: auto;
      background: 0 0;
      right: -60px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

export const HowItWorksTiles: React.FC = () => {
  const { t } = useTranslation('wanted-listings');

  return (
    <Wrapper>
      <WidthWrapper>
        <Content>
          <SimpleWorkTile
            title={t('HOW_IT_WORKS.TILES.ADD_SEARCH.TITLE')}
            description={t('HOW_IT_WORKS.TILES.ADD_SEARCH.DESCRIPTION')}
            color={'green'}
            icon={'edit2'}
          />
          <SimpleWorkTile
            title={t('HOW_IT_WORKS.TILES.RECEIVE_OFFERS.TITLE')}
            description={t('HOW_IT_WORKS.TILES.RECEIVE_OFFERS.DESCRIPTION')}
            color={'yellow'}
            icon={'inbox'}
          />
          <SimpleWorkTile
            title={t('HOW_IT_WORKS.TILES.SIGN_CONTRACT.TITLE')}
            description={t('HOW_IT_WORKS.TILES.SIGN_CONTRACT.DESCRIPTION')}
            color={'blue'}
            icon={'check-circle'}
          />
        </Content>
      </WidthWrapper>
    </Wrapper>
  );
};
